import actions from "./actions";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    jobApplications: [],
    tableLoading: false,
    currentPage: 1,
    status: null,
    perPage: 5,
    searchQuery: "",
    total: 0,
    selectedRow: null,
  },
  actions,
  mutations,
};
